import ActionsForm from '@/shared/mixins/actionsForm'

import {en, es, ptBR} from 'vuejs-datepicker/dist/locale'

import LogModel from '@/shared/models/regulation/auto/sinisterhistorymodel'
import LogRepository from '@/shared/http/repositories/regulation/auto/regulationautolog'
import Forms from '@/components/forms/Forms'
import Tables from '@/components/forms/Tables'
import SinisterHeader from '@/components/regulation/auto/sinisterheader/sinisterheader.vue'
import SinisterHistoryDetails from '@/views/private/regulation/auto/history/SinisterHistoryDetails.vue'

export default {
  name: 'sinisterhistory',
  mixins: [ActionsForm],
  data () {
    return {
      data: LogModel,
      en: en,
      es: es,
      ptBR: ptBR,
      showModal: false,
      previousObject: '',
      newObject: ''
    }
  },
  components: {
    Forms,
    Tables,
    SinisterHeader,
    SinisterHistoryDetails
  },
  methods: {
    onLoad (ID) {
      if (ID && ID !== '00000000-0000-0000-0000-000000000000') {
        this.data.regulationAutoID = ID
        LogRepository.GetById(ID, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then((response) => {
            this.onResultGrid(response)
          })
          .catch((err) => {
            this.onException(err)
          })
      }
    },
    onEdit (action, obj) {
      this.showModal = action
      if (obj != null) {
        this.previousObject = obj.previousObject
        this.newObject = obj.newObject
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/inspection/history/sinisterhistory.js